import * as R from 'ramda';
import { Action } from 'redux';
import { ActionType } from './core/redux/actionType';
import { AppState } from './core/redux/appState';


type SetTimedOutHandleAction = {
  type   : ActionType.SetTimedOutHandleAction;
  handle : number;
}


export const setTimedOutHandleAction = (
  handle: number,
): SetTimedOutHandleAction => ({
  type:   ActionType.SetTimedOutHandleAction,
  handle: handle,
});


export const setTimedOutHandleReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.SetTimedOutHandleAction) {
    return state;
  }

  return R.assoc('timedOutHandle', (action as SetTimedOutHandleAction).handle, state);
};
